import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import api from '@/lib/api';
import { toast } from 'sonner';

function PainelLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [nome, setNome] = useState('');
  const [loading, setLoading] = useState(false);
  const [isSetup, setIsSetup] = useState(false);
  const [checkingSetup, setCheckingSetup] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Se já está logado, ir direto para o painel
    const token = localStorage.getItem('painel_token');
    if (token) {
      navigate('/painel', { replace: true });
      return;
    }
    checkSetup();
  }, [navigate]);

  const checkSetup = async () => {
    try {
      const { data } = await api.get('/painel/auth/check');
      setIsSetup(!data.has_admin);
    } catch (error) {
      console.error(error);
    } finally {
      setCheckingSetup(false);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post('/painel/auth/login', { username, password });
      localStorage.setItem('painel_token', data.access_token);
      localStorage.setItem('painel_user', JSON.stringify(data.user));
      toast.success('Login realizado com sucesso!', { duration: 1500 });
      navigate('/painel');
    } catch (error) {
      toast.error('Credenciais inválidas');
    } finally {
      setLoading(false);
    }
  };

  const handleSetup = async (e) => {
    e.preventDefault();
    if (!nome.trim()) {
      toast.error('Preencha o nome');
      return;
    }
    setLoading(true);
    try {
      await api.post('/painel/auth/setup', { username, password, nome });
      toast.success('Admin master criado! Faça login.');
      setIsSetup(false);
      setNome('');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao criar admin');
    } finally {
      setLoading(false);
    }
  };

  if (checkingSetup) {
    return (
      <div className="min-h-screen bg-obsidian flex items-center justify-center">
        <Loader2 className="w-8 h-8 text-electric-blue animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-obsidian flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-carbon border border-white/10 rounded-xl p-8 shadow-2xl">
          {/* Header */}
          <div className="text-center mb-8">
            <div className="w-20 h-20 bg-gradient-to-br from-electric-blue to-blue-700 rounded-2xl mx-auto flex items-center justify-center mb-4 shadow-lg">
              <Building2 className="w-10 h-10 text-white" />
            </div>
            <h1 className="text-3xl font-bold text-white mb-2">Painel Central</h1>
            <p className="text-slate-400">
              {isSetup ? 'Configure o administrador master' : 'Sistema de Gestão Modular'}
            </p>
          </div>

          {/* Form */}
          <form onSubmit={isSetup ? handleSetup : handleLogin} className="space-y-4">
            {isSetup && (
              <div>
                <Label className="text-slate-400 text-sm">Nome</Label>
                <Input
                  value={nome}
                  onChange={(e) => setNome(e.target.value)}
                  className="bg-obsidian border-white/10 text-white"
                  placeholder="Seu nome completo"
                  required
                />
              </div>
            )}
            <div>
              <Label className="text-slate-400 text-sm">Usuário</Label>
              <Input
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="bg-obsidian border-white/10 text-white"
                placeholder="Digite seu usuário"
                required
              />
            </div>
            <div>
              <Label className="text-slate-400 text-sm">Senha</Label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="bg-obsidian border-white/10 text-white"
                placeholder="Digite sua senha"
                required
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-electric-blue hover:bg-blue-600 text-white font-medium py-6"
            >
              {loading ? (
                <Loader2 className="w-5 h-5 animate-spin" />
              ) : isSetup ? (
                'CRIAR ADMIN MASTER'
              ) : (
                'ENTRAR'
              )}
            </Button>
          </form>
        </div>

        <p className="text-center text-slate-600 text-xs mt-6">
          Sistema de Gestão Modular v1.0.0
        </p>
      </div>
    </div>
  );
}

export default PainelLogin;
